import loadable from '@loadable/component';
import { Skeleton } from 'aui';
import { ClientOnly } from 'remix-utils/client-only';
import type { DocSearchProps } from './index';

const AlgoliaSearchBar = loadable(() => import('./index'), {
  fallback: (
    <Skeleton.Input
      active
      block
      style={{ background: 'var(--ui-input-bg)', borderRadius: 'var(--ui-control-border-radius)' }}
    />
  ),
});

type AlgoliaSearchBarProps = DocSearchProps;
export default function AsyncAlgoliaSearchBar(props: AlgoliaSearchBarProps) {
  return (
    <ClientOnly
      fallback={
        <Skeleton.Input
          active
          block
          style={{
            background: 'var(--ui-input-bg)',
            borderRadius: 'var(--ui-control-border-radius)',
          }}
        />
      }
    >
      {() => <AlgoliaSearchBar {...props} />}
    </ClientOnly>
  );
}
